import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import HeroSection from "./components/landingPage/Hero";
import Sidebar from "./components/layout/Sidebar";
import Listing from "./components/listing/Listing";
import ReportDetail from "./components/listing/ReportDetail";
import Companies from "./components/Company/companies";
import CompanyDetail from "./components/Company/CompanyDetail";
import ReportType2 from "./components/reportType/ReportType2";
import ReportType3 from "./components/reportType/ReportType3";
import ResponsiveTable from "./components/reportType/Statisitcs";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Pricing from "./components/pages/Pricing";
import Profile from "./components/pages/Profile";
// import SavedReports from "./components/pages/SavedReports";
import AllReports from "./components/pages/AllReports";
import ConsumerInsights from "./components/pages/ConsumerInsights";
import ReportType1 from "./components/reportType/ReportType1";
import HelpFaq from "./components/pages/Help&Faq";
import AccountSettings from "./components/pages/AccountSettings";
import ContactComponent from "./components/pages/ContactUs";
import Esg from "./components/pages/Esg";
import AdminLogin from "./components/admin/login/login";
import AdminRegister from "./components/admin/login/register";
import Dashboard from "./components/admin/AdminDashboard";
import Plans from "./components/admin/adminPages/plans";
import LoginModal from "./components/layout/LoginModal";
import UserList from "./components/admin/adminPages/userList";
import ReportCountry from "./components/listing/ReportCountry";
import ReportRegion from "./components/listing/ReportRegion";
import UploadReport from "./components/admin/adminPages/UploadReports";
import UploadCompanies from "./components/admin/adminPages/UploadCompanydetail";
import Editreport from "./components/admin/adminPages/EditReport";
import AdminContactus from "./components/admin/adminPages/contactUs";
import EditSingleReport from "./components/admin/adminPages/singleReportEdit";
import CompanyList from "./components/admin/adminPages/CompanyList";
import AllSubscribers from "./components/admin/adminPages/PendingSubscribers";
import PendingSubscribers from "./components/admin/adminPages/PendingSubscribers";
import ApprovedSubscribers from "./components/admin/adminPages/ApprovedSubscribers";
import ManagePlan from "./components/pages/ManagePlan";
import PaymentStatus from "./components/Payment/payment";
import SubscriptionFailure from "./components/Payment/SubscriptionFailure";
import SubscriptionConfirmation from "./components/Payment/SubscriptionConfirmation";
import AllIndustries from "./components/listing/AllIndustries";
import AllReviews from "./components/admin/adminPages/AllReviews";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import BillingHistory from "./components/pages/BillingHistory";
import RegisterWithOTP from "./components/layout/RegisterModal";
import Termofuse from "./components/pages/TermofUse";
import ForgotPassword from "./components/layout/ForgotPassword";
import ResetPassword from "./components/layout/ResetPassword";

const App = () => (
  <Router>
    <MainContent />
  </Router>
);

const MainContent = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  // const [isPinned, setIsPinned] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  // const handleMouseEnter = () => setIsExpanded(true);
  // const handleMouseLeave = () => !isPinned && setIsExpanded(false);
  // const handleClick = () => {
  //   console.log("Before toggle:", isExpanded); // Check the current state

  //   if (!isExpanded) {
  //     setIsPinned(true);
  //     setIsExpanded(true);
  //   } else if (isExpanded) {
  //     setIsExpanded(false);
  //     setIsPinned(false);
  //   }
  const handleClick = () => {
    // setIsExpanded(!isExpanded);
    // setIsPinned(!isPinned);
    if (isExpanded) {
      setIsExpanded(false);
    } else {
      setIsExpanded(true);
    }
  };

  //   console.log("After:", { isExpanded, isPinned }); // Debug updated values
  // };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tokenExpiration = localStorage.getItem("tokenExpiration");
      const isTokenExpired =
        tokenExpiration && new Date(tokenExpiration) < new Date();

      if (isTokenExpired) {
        // ["token", "userId", "userID", "isLogin", "tokenExpiration"].forEach((key) =>
        // );
        localStorage.clear();
        alert("Your session has expired. Please log in again.");
        navigate("/");
      }
    }
  }, [navigate]);

  useEffect(() => {
    // console.log("Updated State:", { isExpanded }); // Logs after state changes
  }, [isExpanded]); // Log whenever these states change

  const sidebarWidth = isExpanded ? "w-72" : "w-32";

  // Check if the current path is an admin route
  const isRoute = location.pathname.startsWith("/admin/");
  // const adminToken = localStorage.getItem("Admin_Token");
  // Redirect to /admin/login if trying to access an admin page without a token
  // if (isRoute && !adminToken && location.pathname !== "/admin/login") {
  //   return <Navigate to="/admin/login" />;
  // }

  console.log(!isRoute, "isRoute");
  return (
    <div className="flex justify-between w-full" id="globalDiv">
      {/* Sidebar should be hidden on admin routes */}
      {!isRoute && (
        <div
          className={`${sidebarWidth} transition-all duration-500 ease-[cubic-bezier(0.4, 0, 0.2, 1)] h-screen sticky z-10 top-0 shadow-xl hidden lg:block`}
          // onMouseEnter={handleMouseEnter}
          // onMouseLeave={handleMouseLeave}
        >
          <Sidebar
            isExpanded={isExpanded}
            handleClick={handleClick}
            // isPinned={isPinned}
          />
        </div>
      )}

      <div className="lg:w-[100%]" id="fullWidthNew">
        {/* Navbar should be hidden on admin routes */}
        {!isRoute && <Navbar />}

        <Routes>
          {/* Public routes */}
          {!isRoute ? (
            <>
              <Route exact path="/" element={<HeroSection />} />
              <Route exact path="/listing" element={<Listing />} />
              <Route path="/report" element={<ReportDetail />} />
              <Route path="/report1" element={<ReportType1 />} />
              <Route path="/report2" element={<ReportType2 />} />
              <Route path="/report3" element={<ReportType3 />} />
              <Route path="/stats" element={<ResponsiveTable />} />
              <Route path="/companies" element={<Companies />} />
              <Route path="/company-details" element={<CompanyDetail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/saved-reports" element={<AllReports />} />
              <Route path="/consumer-insights" element={<ConsumerInsights />} />
              <Route path="/help" element={<HelpFaq />} />
              <Route path="/account" element={<AccountSettings />} />
              <Route path="/contact-us" element={<ContactComponent />} />
              <Route path="/esg-consulting" element={<Esg />} />
              <Route path="/login" element={<LoginModal />} />
              <Route path="/register" element={<RegisterWithOTP />} />
              <Route path="/report-country" element={<ReportCountry />} />
              <Route path="/report-region" element={<ReportRegion />} />
              <Route path="/help&faq" element={<HelpFaq />} />
              <Route path="/manageplans" element={<ManagePlan />} />
              <Route path="/subscription-status" element={<PaymentStatus />} />
              <Route
                path="/subscription-failure"
                element={<SubscriptionFailure />}
              />
              <Route
                path="/subscription-confirmation"
                element={<SubscriptionConfirmation />}
              />
              <Route path="/All-Industries" element={<AllIndustries />} />
              <Route path="/Privacy-Policy" element={<PrivacyPolicy />} />
              <Route path="/Billing-History" element={<BillingHistory />} />
              <Route path="/Term-of-Use" element={<Termofuse />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/reset-password/:token"
                element={<ResetPassword />}
              />
            </>
          ) : (
            // Admin routes
            <>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/register" element={<AdminRegister />} />
              <Route path="/admin/dashboard" element={<Dashboard />} />
              <Route path="/admin/plans" element={<Plans />} />
              <Route path="/admin/userlist" element={<UserList />} />
              <Route path="/admin/reviews" element={<UserList />} />
              <Route path="/admin/upload" element={<UploadReport />} />
              <Route path="/admin/companies" element={<UploadCompanies />} />
              <Route path="/admin/report/view" element={<Editreport />} />
              <Route path="/admin/report/edit" element={<EditSingleReport />} />
              <Route path="/admin/contactUs" element={<AdminContactus />} />
              <Route path="/admin/AllCompanies" element={<CompanyList />} />
              <Route path="/admin/all-reviews" element={<AllReviews />} />
              <Route
                path="/admin/pending/subscribers"
                element={<PendingSubscribers />}
              />
              <Route
                path="/admin/approved/subscribers"
                element={<ApprovedSubscribers />}
              />
              {/* You can add more admin routes here */}
            </>
          )}
        </Routes>
        {/* Footer should be hidden on admin routes */}
        {!isRoute && <Footer />}
      </div>
    </div>
  );
};

export default App;
